export const patientSchedules = {
  title: 'Patient Schedules',
  allOption: 'All',
  companyLabel: 'Pharmacy',
  selectOptionPlaceholder: 'Select an option...',
  dateRangeLabel: 'Schedules date range',
  copyTodayScheduleButton: "Copy Today's Schedule Times",
  exportToExcelButton: 'Export to Excel',
  hideCompletedLabel: 'Hide Completed',
  todayFilterLabel: 'Today',
  thisWeekFilterLabel: 'This Week (Mon–Sat)',
  unknownVisitType: 'Unknown',
  timezoneNoticePrefix: 'All times shown below are in',
  defaultTimezoneLabel: 'your local timezone',
  scheduleStatus: {
    title: 'Schedule Status',
    completeSuffix: 'complete',
    totalPatientsLabel: 'Total Patients',
    completeLabel: 'Complete',
    incompleteLabel: 'Incomplete'
  },
  csvHeaders: {
    patientName: 'Name (Last, First)',
    pharmacy: 'Pharmacy',
    appointmentTimestamp: 'Appointment Timestamp',
    visitType: 'Visit Type',
    signedOff: 'Signed Off',
    patientLink: 'Patient Link'
  },
  grid: {
    patientName: 'Patient Name (Last, First)',
    pharmacyName: 'Pharmacy Name',
    scheduledAt: 'Scheduled At',
    apptDate: 'Appt Date',
    apptTime: 'Appt Time',
    visitType: 'Visit Type',
    rpmStatus: 'RPM Status',
    ccmStatus: 'CCM Status',
    telehealthCheckedIn: 'Telehealth Checked-In',
    signedOffOn: 'Signed Off On',
    scheduledOn: 'Scheduled On'
  },
  snackbars: {
    fetchTodayFailed: "Failed to fetch today's follow-ups. Please try again later.",
    noSchedulesToday: 'No schedules found for today.',
    copySuccess: "Copied today's schedules to clipboard.",
    copyFailed: "Failed to copy today's schedules. Please try again.",
    noSchedulesToExport: 'No schedules found to export for the selected filters.',
    exportFailed: 'Failed to export patient schedules. Please try again.'
  }
} as const;
